export const PORTFOLIO_DOWNLOAD_FILENAME = 'liva-vilnite-portfolio.pdf';
export const PORTFOLIO_DOWNLOAD_PATH = `${process.env.PUBLIC_URL}/downloads/${PORTFOLIO_DOWNLOAD_FILENAME}`;
